module.exports = __webpack_public_path__ + "img/binding3.5dcbeedb.jpg";